import { render } from "./LaravelVueDatatablesCellBody.vue?vue&type=template&id=5481ef43"
import script from "./LaravelVueDatatablesCellBody.vue?vue&type=script&lang=js"
export * from "./LaravelVueDatatablesCellBody.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__